import { IFolderRegistry, IFolderService, IFolderRepository } from "../../domain/folder";
import { FolderRepository } from "./FolderRepository";
import { FolderService } from "./FolderService";

export class FolderRegistry implements IFolderRegistry {
  constructor(getToken: () => string) {
    this._service = new FolderService();
    this._repository = new FolderRepository(getToken);
  }

  private readonly _service: IFolderService;
  private readonly _repository: IFolderRepository;

  getFolderService(): IFolderService {
    return this._service;
  }

  getFolderRepository(): IFolderRepository {
    return this._repository;
  }
}
